(function () {
  class ProductQuickAdd {
    constructor(el) {
      this.el = el;

      // Beobachtet den Produktbereich (Sichtbarkeit)
      const productSection = document.querySelector('.product-information');
      if (!productSection) return;

      this.io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.hide();
            } else {
              this.show();
            }
          });
        },
        { threshold: 0 }
      );

      this.io.observe(productSection);
      this.el.hidden = false;
      this.el.setAttribute('aria-hidden', 'true');

      // Sticky-Button klickt den echten "Add to Cart"-Button
      const stickyButton = this.el.querySelector('[data-qa-add]');
      stickyButton.addEventListener('click', () => {
        const realButton = document.querySelector('add-to-cart-component button[type="submit"], .add-to-cart-button');
        if (realButton) realButton.click();
      });
    }

    show() {
      this.el.classList.add('is-visible');
      this.el.setAttribute('aria-hidden', 'false');
    }

    hide() {
      this.el.classList.remove('is-visible');
      this.el.setAttribute('aria-hidden', 'true');
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-product-quick-add]').forEach((el) => new ProductQuickAdd(el));
  });
})();

// Footer-Erkennung für Sticky Quick Add
const quickAdd = document.querySelector('.product-quick-add');

// Wir suchen nach allen möglichen Footer-Varianten
const footer =
  document.querySelector('footer') ||
  document.querySelector('[id*="footer"]') ||
  document.querySelector('.shopify-section-footer');

if (footer && quickAdd) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          quickAdd.classList.add('is-hidden-near-footer');
        } else {
          quickAdd.classList.remove('is-hidden-near-footer');
        }
      });
    },
    {
      root: null,
      threshold: 0.1,
    }
  );

  observer.observe(footer);
}